<template>
  <div class="width-100 height-100 pdf-wrapper">
    <div
      v-if="!iframeReady"
      class="pdf-loading">
      <sIcon
        class="mt-10"
        color="#ced8d7"
        size="50"
        spin
        type="loading"/>
    </div>
    <iframe
      v-show="iframeReady"
      ref="pdf_iframe"
      class="pdf-iframe"
      sandbox="allow-same-origin allow-forms allow-storage-access-by-user-activation allow-scripts allow-modals allow-popups allow-downloads allow-popups-to-escape-sandbox"
      :src="iframeSrc"
      @load="onIframeLoad"/>
  </div>
</template>
<script>
import theme from 'mixins/theme'

export default {
  name: 'DocumentPdfView',
  mixins: [ theme ],
  data() {
    return {
      iframeReady: false,
    }
  },
  computed: {
    iframeSrc() {
      const lang = this.$i18n?.locale || 'uk'
      const microserviceUrl = (window.config.MicroserviceUrl || '/').replace(/\/$/, '')
      return `${microserviceUrl}/app/mf/commercial-pdf-view/?lang=${lang}`
    },
    iframeOrigin() {
      const microserviceUrl = window.config.MicroserviceUrl || '/'
      try { return new URL(microserviceUrl).origin } catch { return '*' }
    },
  },
  methods: {
    onIframeLoad() {
      if (!this.iframeReady) {
        this.iframeReady = true
        this.sendTheme()
        this.sendLoadPdf()
      }
    },
    sendLoadPdf() {
      if (!this.urlView || !this.$refs.pdf_iframe?.contentWindow) {
        return
      }
      const token = this.$auth?.user?.access_token || ''
      const msg = {
        type: 'load-pdf',
        url: this.urlView,
        ...(token && { headers: { Authorization: `Bearer ${token}` } }),
      }
      this.$refs.pdf_iframe.contentWindow.postMessage(msg, this.iframeOrigin)
    },
    sendTheme() {
      if (!this.$refs.pdf_iframe?.contentWindow) {
        return
      }
      const dark = this.$vuetify?.theme?.dark ?? false
      this.$refs.pdf_iframe.contentWindow.postMessage(
        { type: 'set-theme', theme: dark ? 'dark' : 'light' },
        this.iframeOrigin,
      )
    },
    onMessage(event) {
      const isOurIframe = event.source === this.$refs.pdf_iframe?.contentWindow
      if (!isOurIframe) {
        return
      }
      if (event.data?.type === 'app:ready' && event.data?.source === 'commercial-pdf-view') {
        this.iframeReady = true
        this.sendTheme()
        this.sendLoadPdf()
      }
    },
  },
  watch: {
    urlView(val) {
      if (val && this.iframeReady) {
        this.sendLoadPdf()
      }
    },
    userTheme() {
      if (this.iframeReady) {
        this.sendTheme()
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.onMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessage)
  },
  props: {
    urlView: {
      type: String,
      default: '',
    },
  },
}
</script>
<style scoped lang="scss">
.pdf-wrapper {
  position: relative;
}
.pdf-iframe {
  width: 100%;
  height: calc(100% - 6px);
  border: none;
}
.pdf-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
